export enum Language {
    Danish = 'da',
    English = 'en'
}